(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wow-consent-banner"] && !Shopify.designMode) return;
  try {
    (() => {
      const root = document.querySelector('[data-wow-consent-root]');
      if (!root || root.dataset.initialized === 'true') return;

      root.dataset.initialized = 'true';

      const banner = root.querySelector('[data-wow-consent-banner]');
      const dialog = root.querySelector('[data-wow-consent-dialog]');
      const saleDialog = root.querySelector('[data-wow-consent-sale-dialog]');
      const saleOptOutButton = root.querySelector('[data-wow-consent-action="sale-opt-out"]');
      const saleOpenButtons = document.querySelectorAll('[data-wow-consent-sale-open]');
      const statusNodes = root.querySelectorAll('[data-wow-consent-status]');
      const errorMessage = root.querySelector('[data-wow-consent-error]').textContent.trim();
      const savingMessage = root.querySelector('[data-wow-consent-saving]').textContent.trim();
      const savedMessage = root.querySelector('[data-wow-consent-saved]').textContent.trim();
      const saleSavedMessage = root.querySelector('[data-wow-consent-sale-saved]').textContent.trim();
      const saleCurrentMessage = root.querySelector('[data-wow-consent-sale-current]').textContent.trim();
      const showGlobally = root.dataset.showGlobally === 'true';
      const policyVersion = root.dataset.policyVersion || '2026-07-20';
      let privacyApi = null;
      let bannerWasVisible = false;
      let saleBannerWasVisible = false;

      const categoryInputs = {
        preferences: root.querySelector('[data-wow-consent-category="preferences"]'),
        analytics: root.querySelector('[data-wow-consent-category="analytics"]'),
        marketing: root.querySelector('[data-wow-consent-category="marketing"]')
      };

      const setStatus = (message) => {
        statusNodes.forEach((node) => {
          node.textContent = message;
          node.hidden = !message;
        });
      };

      const setBusy = (busy) => {
        root.querySelectorAll('[data-wow-consent-action="accept"], [data-wow-consent-action="reject"], [data-wow-consent-action="save"], [data-wow-consent-action="sale-opt-out"]').forEach((button) => {
          button.disabled = busy;
        });
      };

      const getConsent = () => {
        if (!privacyApi) return {};

        try {
          return privacyApi.currentVisitorConsent() || {};
        } catch (error) {
          return {};
        }
      };

      const hasCookieDecision = (consent) =>
        ['preferences', 'analytics', 'marketing'].some(
          (category) => consent[category] === 'yes' || consent[category] === 'no'
        );

      const saleRegion = () => {
        if (!privacyApi) return false;

        try {
          return Boolean(privacyApi.saleOfDataRegion());
        } catch (error) {
          return false;
        }
      };

      const populateChoices = () => {
        const consent = getConsent();
        categoryInputs.preferences.checked = consent.preferences === 'yes';
        categoryInputs.analytics.checked = consent.analytics === 'yes';
        categoryInputs.marketing.checked = consent.marketing === 'yes';
      };

      const updateSaleControls = () => {
        const available = saleRegion();
        saleOpenButtons.forEach((button) => {
          button.hidden = !available;
        });
      };

      const categoryExplicitlyAllowed = (category, consent) =>
        category === 'essential' || consent[category] === 'yes';

      const refreshManualContent = () => {
        const consent = getConsent();

        document.querySelectorAll('script[type="text/plain"][data-wow-consent-category]').forEach((source) => {
          const category = source.dataset.wowConsentCategory;
          if (!categoryExplicitlyAllowed(category, consent) || source.dataset.wowConsentActivated === 'true') return;

          const runtime = document.createElement('script');
          Array.from(source.attributes).forEach((attribute) => {
            if (!['type', 'data-src', 'data-wow-consent-category', 'data-wow-consent-activated'].includes(attribute.name)) {
              runtime.setAttribute(attribute.name, attribute.value);
            }
          });

          if (source.dataset.src) runtime.src = source.dataset.src;
          runtime.dataset.wowConsentRuntime = category;
          runtime.textContent = source.textContent;
          source.dataset.wowConsentActivated = 'true';
          source.after(runtime);
        });

        document.querySelectorAll('iframe[data-wow-consent-category][data-src]').forEach((frame) => {
          const allowed = categoryExplicitlyAllowed(frame.dataset.wowConsentCategory, consent);
          if (allowed && !frame.getAttribute('src')) frame.setAttribute('src', frame.dataset.src);
          if (!allowed && frame.getAttribute('src')) frame.removeAttribute('src');
        });
      };

      const announceConsent = () => {
        const consent = getConsent();
        document.dispatchEvent(new CustomEvent('wow:consent-updated', { detail: consent }));
      };

      const shouldReloadForWithdrawal = (payload) => {
        const before = getConsent();
        return ['preferences', 'analytics', 'marketing'].some(
          (category) => before[category] === 'yes' && payload[category] === false
        );
      };

      const closeDialog = () => {
        if (typeof dialog.close === 'function' && dialog.open) {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
        }

        if (bannerWasVisible) banner.hidden = false;
      };

      const openDialog = () => {
        bannerWasVisible = !banner.hidden;
        banner.hidden = true;
        populateChoices();
        setStatus('');

        if (typeof dialog.showModal === 'function') {
          if (!dialog.open) dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
      };

      const closeSaleDialog = () => {
        if (typeof saleDialog.close === 'function' && saleDialog.open) {
          saleDialog.close();
        } else {
          saleDialog.removeAttribute('open');
        }

        if (saleBannerWasVisible) banner.hidden = false;
      };

      const openSaleDialog = () => {
        saleBannerWasVisible = !banner.hidden;
        banner.hidden = true;
        const alreadyOptedOut = getConsent().sale_of_data === 'no';
        saleOptOutButton.disabled = alreadyOptedOut;
        setStatus(alreadyOptedOut ? saleCurrentMessage : '');

        if (typeof saleDialog.showModal === 'function') {
          if (!saleDialog.open) saleDialog.showModal();
        } else {
          saleDialog.setAttribute('open', '');
        }
      };

      const completeConsent = (reload) => {
        bannerWasVisible = false;
        banner.hidden = true;
        setBusy(false);
        setStatus(savedMessage);
        refreshManualContent();
        announceConsent();

        if (typeof dialog.close === 'function' && dialog.open) dialog.close();
        if (reload) window.location.reload();
      };

      const saveConsent = (payload) => {
        if (!privacyApi) {
          setStatus(errorMessage);
          return;
        }

        const reload = shouldReloadForWithdrawal(payload);
        payload.metafields = [{ key: 'wow-consent-v', value: policyVersion }];
        setBusy(true);
        setStatus(savingMessage);

        privacyApi.setTrackingConsent(payload, (error) => {
          if (error) {
            setBusy(false);
            setStatus(errorMessage);
            return;
          }

          completeConsent(reload);
        });
      };

      const saveCustomChoices = () => {
        const payload = {
          preferences: categoryInputs.preferences.checked,
          analytics: categoryInputs.analytics.checked,
          marketing: categoryInputs.marketing.checked
        };

        saveConsent(payload);
      };

      const saveSaleOptOut = () => {
        if (!privacyApi) {
          setStatus(errorMessage);
          return;
        }

        setBusy(true);
        setStatus(savingMessage);

        privacyApi.setTrackingConsent(
          {
            sale_of_data: false,
            metafields: [{ key: 'wow-consent-v', value: policyVersion }]
          },
          (error) => {
            setBusy(false);
            if (error) {
              setStatus(errorMessage);
              return;
            }

            saleOptOutButton.disabled = true;
            setStatus(saleSavedMessage);
            announceConsent();
          }
        );
      };

      root.addEventListener('click', (event) => {
        const button = event.target.closest('[data-wow-consent-action]');
        if (!button) return;

        const action = button.dataset.wowConsentAction;
        if (action === 'accept') {
          saveConsent({ preferences: true, analytics: true, marketing: true });
        } else if (action === 'reject') {
          saveConsent({ preferences: false, analytics: false, marketing: false });
        } else if (action === 'customize') {
          openDialog();
        } else if (action === 'save') {
          saveCustomChoices();
        } else if (action === 'close') {
          closeDialog();
        } else if (action === 'sale-opt-out') {
          saveSaleOptOut();
        } else if (action === 'sale-close') {
          closeSaleDialog();
        }
      });

      document.querySelectorAll('[data-wow-consent-open]').forEach((button) => {
        button.addEventListener('click', openDialog);
      });

      saleOpenButtons.forEach((button) => {
        button.addEventListener('click', openSaleDialog);
      });

      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        closeDialog();
      });

      saleDialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        closeSaleDialog();
      });

      document.addEventListener('visitorConsentCollected', () => {
        const consent = getConsent();
        if (hasCookieDecision(consent)) banner.hidden = true;
        populateChoices();
        updateSaleControls();
        refreshManualContent();
        announceConsent();
      });

      const initialize = () => {
        if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
          banner.hidden = false;
          setStatus(errorMessage);
          return;
        }

        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          (error) => {
            if (error || !window.Shopify.customerPrivacy) {
              banner.hidden = false;
              setStatus(errorMessage);
              return;
            }

            privacyApi = window.Shopify.customerPrivacy;
            const consent = getConsent();
            let apiRequestsBanner = false;

            try {
              apiRequestsBanner = Boolean(privacyApi.shouldShowBanner());
            } catch (privacyError) {
              apiRequestsBanner = false;
            }

            populateChoices();
            updateSaleControls();
            refreshManualContent();
            banner.hidden = !(apiRequestsBanner || (showGlobally && !hasCookieDecision(consent)));
          }
        );
      };

      initialize();
    })();
  } catch(e) { console.error(e); }
})();

})();
